export default "__VITE_ASSET__C02Mb6jP__"